export enum McpTokenScope {
    READ = 'read',
    WRITE = 'write',
}

export enum McpTokenKind {
    PERSONAL = 'personal',
    OAUTH = 'oauth',
}

export enum McpOauthGrantType {
    AUTHORIZATION_CODE = 'authorization_code',
    REFRESH_TOKEN = 'refresh_token',
}

export const MCP_OAUTH_CODE_CHALLENGE_METHOD = 'S256';
